module.exports = __webpack_public_path__ + "img/hn.hn5ef17b2.svg";